import { render } from "./newAccessoire.vue?vue&type=template&id=e64a9b66&scoped=true"
import script from "./newAccessoire.vue?vue&type=script&lang=js"
export * from "./newAccessoire.vue?vue&type=script&lang=js"

import "./newAccessoire.vue?vue&type=style&index=0&id=e64a9b66&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64a9b66"]])

export default __exports__